import { useParams } from "react-router-dom";
import { Col } from "@neumetric/blueprint-lib/components";
import { AuditReport } from "../Common";

export const AuditReportScreen = (props) => {
  const { asmtId } = useParams();

  return (
    <Col className="w-100 h-100 overflow-hide">
      <AuditReport asmtId={asmtId} allowEdit={true} showHeader={true} />
    </Col>
  );
};
